import { deviceApi } from "../../api/deviceApi.js"

import { deviceListSignal, deviceListLoadedSignal, deviceListErrorSignal } from '../signals/deviceSignals'
import { addNotification, NotificationTypes } from './notificationActions.js'

export async function fetchDeviceList(businessEntityId, filters, config, accessToken, includeChildren = false) {
    deviceListLoadedSignal.value = false
    deviceListSignal.value = []
    const resolvedFilters = includeChildren
        ? { ...(filters ?? { Predicates: [] }), IncludeChildAccounts: true }
        : (filters ?? { Predicates: [] })
    return await deviceApi.fetchDeviceList(businessEntityId, resolvedFilters, config, accessToken).then(
        (result) => {
            deviceListSignal.value = result
            deviceListLoadedSignal.value = true
            return result
        }
    ).catch(
        (err) => {
            deviceListErrorSignal.value = err.message
        }
    )
}

export const exportDeviceList = async (businessEntityId, filters, columns, config, accessToken) => {
    return await deviceApi.exportDeviceList(businessEntityId, filters, columns, config, accessToken)
}